<template>
    <div class="jd-page--identify">
        <div class="jd-block__title">专家鉴定</div>
        <k-cell-group v-if="getOrderDetail">
            <k-field label="鉴定人" v-model="expert" readonly placeholder="" />
            <k-field label="藏品名称：" v-model.trim="info.definition" maxlength="30" placeholder="请输入藏品名称" />
            <k-field label="藏品断代：" v-model="info.periods" placeholder="请选择年代" readonly right-icon="arrow" @click="popup('year')"  />
            <k-field label="价格趋势：" v-model="info.trend" placeholder="请选择价格趋势" readonly right-icon="arrow" @click="popup('trend')" />
            <k-field label="鉴定结果：" v-model="info.isReal" placeholder="请选择鉴定结果！" right-icon="arrow" readonly @click="popup('conclusion')" />
            <k-field label="证书封面图：" v-model="info.cover" placeholder="请选择一张图片作为证书图片！" right-icon="arrow" readonly @click="coverPop=true" />
            <k-field label="鉴定评语：" v-model="info.reply" type="textarea" maxlength="500" placeholder="简要说明鉴定结果！" rows="3" autosize>
                <template slot="input">
                    <k-textarea :max-length="120" v-model="info.reply" placeholder="简要说明鉴定结果！" />
                </template>
            </k-field>
            <!--<div class="jd-cell">
                <k-button type="default" block>证书预览</k-button>
            </div>-->
            <br/>
        </k-cell-group>
        <template v-if="getOrderDetail">
            <goods-info :des="getOrderDetail.des || ''" :files="getOrderDetail.files" :pictures="getOrderDetail.pictures" :num="true">
<!--                <span slot="right" class="cl-primary">鉴定倒计时 23:55:10</span>-->
            </goods-info>
        </template>


        <div class="jd-fixed-btns" v-if="getOrderDetail">
            <k-row gutter="10">
                <k-col v-if="getOrderDetail.status === CONST.ORDER_STATUS_WAIT" span="12"><k-button type="primary" block @click="save(0)">保存</k-button></k-col>
                <k-col v-if="showJdBtn" :span="getOrderDetail.status === CONST.ORDER_STATUS_WAIT?12:24"><k-button type="danger" block @click="save(1)" :disabled="!replyUser">{{getOrderDetail.status === CONST.ORDER_STATUS_WAIT?'提交给用户':'保存修改'}}</k-button></k-col>
            </k-row>
        </div>

        <k-popup v-model="popupShow" position="bottom" @closed="popupClose">
                <select-radio v-show="popupType==='trend'" :columns="trendList" :default-index="trendKey" @change="onChangeTrend" />
                <select-radio v-show="popupType==='year'" :columns="yearsList" :default-index="yearsKey" @change="onChangeYear" />
                <select-radio v-show="popupType==='conclusion'" :columns="realList" :default-index="realKey" @change="onReal" />
<!--            <k-picker v-if="popupType" :columns="trendList" :default-index="trendIndex" @change="onChangeTrend" />-->
<!--            <k-picker v-else :columns="yearsList" :default-index="yearsIndex" title="选择年代"  @change="onChangeYear" />-->
        </k-popup>
        <k-action-sheet v-model="coverPop" title="选择证书使用图片">
            <div v-if="getOrderDetail" class="pd-xl ta-center">
                <k-tag v-for="(item,index) in getOrderDetail.pictures" :color="(coverRid===item.rid)?'#CEA065':''" :key="item.rid" :plain="(coverRid===item.rid)?false:true" @click="selectCoverIndex(item.rid,index)">图{{index+1}}</k-tag>
            </div>
        </k-action-sheet>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex"
    import GoodsInfo from "../components/goods-info"
    import {cfg2arr} from "../../utils/app";
    import SelectRadio from "./mod/select-radio"
    import {getArrIndex} from "../../utils/xp.v1"
    export default {
        name: "identify",
        data() {
            return {
                popupShow       : false,
                coverPop        : false,
                id              : this.$route.query.orderId || 0,
                info : {
                    orderId     : this.$route.query.orderId || 0,
                    do          : 0,
                    definition  : "",
                    periods     : "",
                    trend       : "",
                    reply       : "",
                    cover       : "",
                    isReal       : ''
                },
                //yearsList: ['当代', '夏朝', '商朝', '周朝', '秦朝', '汉朝', '三国', '晋朝', '南北朝', '隋唐', '宋朝', '元朝', '明朝', '清朝'],
                //trendList: ['不宜评估', '价格透明稳定', '价格趋向上涨', '升值空间较大', '行情波动较大'],
                popupType       : 0,
                yearsIndex      : 0,
                trendIndex      : 0,
                yearsKey        : 0,
                trendKey        : 0,
                coverRid        : 0,
                realKey         : 0,
                replyUser       : false
            }
        },
        computed : {
            ...mapGetters("jianding", ["getOrderDetail","CONST","cfgPeriods","cfgTrend","cfgIsReal"]),
            showJdBtn() {
                let {status} = this.getOrderDetail;
                let {ORDER_STATUS_WAIT, ORDER_STATUS_FINISHED, ORDER_STATUS_EVALUATE} = this.CONST;
                if(status === ORDER_STATUS_WAIT || status === ORDER_STATUS_FINISHED || status === ORDER_STATUS_EVALUATE){
                    return true
                }
                return false
            },
            expert(){
                let { appraiser } = this.getOrderDetail
                return appraiser.name || ""
            },
            yearsList(){
                //return cfg2arr(this.cfgPeriods)
                return this.cfgPeriods
            },
            trendList(){
                //return cfg2arr(this.cfgTrend)
                return this.cfgTrend
            },
            realList(){
                //return cfg2arr(this.cfgTrend)
                return this.cfgIsReal
            }
        },
        components : {
            GoodsInfo,
            SelectRadio
        },
        methods : {
            ...mapActions("jianding",["startAppraisal", "loadOrderDetail", "loadConfig"]),
            selectCoverIndex(rid, index){
                this.info.cover = `图${index + 1}`
                this.coverRid   = rid
            },
            async save(type) {
                this.info.do = type || 0;
                let {orderId, definition, periods, trend, reply, cover} = this.info;
                let {yearsKey, trendKey, realKey, coverRid} = this;
                if(!yearsKey){
                    this.$toast('年代有KEY有误');
                    return
                }
                if(!trendKey){
                    this.$toast('价格趋势KEY有误');
                    return
                }
                if(!realKey){
                    this.$toast('请选择鉴定结果');
                    return
                }
                if(!coverRid){
                    this.$toast('请选择鉴定证书封面图');
                    return
                }
                if(!reply || reply.length < 1){
                    this.$toast('请输入鉴定描述!');
                    return
                }
                let query = {
                    do : type,
                    orderId,
                    definition,
                    periods : yearsKey,
                    trend   : trendKey,
                    reply,
                    cover   : coverRid,
                    isReal  : realKey
                };
                await this.startAppraisal(query).then( R => {
                    this.$toast.success("操作成功")
                    if(type){
                        this.$router.push({path:'/appraiser/order'})
                    }
                }).catch( err => {
                    this.$toast.fail(err.message)
                });
                console.log(JSON.stringify(this.info,null, 2))
            },
            onChangeYear(data){
                console.log(JSON.stringify(data));
                this.info.periods       = data.text;
                this.yearsKey           = data.key;
            },
            onChangeTrend(data){
                console.log(JSON.stringify(data));
                this.info.trend         = data.text;
                this.trendKey           = data.key;
            },
            onReal(data){
                console.log(JSON.stringify(data));
                this.info.isReal        = data.text;
                this.realKey            = data.key;
            },
            popup(type){
                this.popupType          = type;
                this.popupShow          = true;
            },
            selectYear(value, index){
                console.log(value, index)
            },
            popupClose(){
                // 关闭选择时如果没有选择就给个默认值
                /*if(this.popupType === 0 && this.yearsIndex === 0){
                    this.info.periods   = this.yearsList[0];
                }
                if(this.popupType === 1 && this.trendIndex === 0){
                    this.info.trend     = this.trendList[0];
                }*/
            }
        },
        async mounted() {
            if(!this.cfgPeriods){
                await this.loadConfig();
            }
            await this.loadOrderDetail({id:this.id});
        },
        watch : {
            info : {
                handler(nv){
                    if(nv.definition && nv.periods && nv.trend && nv.reply){
                        this.replyUser  = true
                    } else {
                        this.replyUser  = false
                    }
                },
                deep : true
            },
            getOrderDetail : {
                handler(nv){
                    if(nv){
                        let {definition, periods, trend, reply, pictures, isReal, cover} = nv;
                        this.info       = Object.assign(this.info, {
                            definition,
                            periods : this.cfgPeriods[periods] || "",
                            trend : this.cfgTrend[trend] || "",
                            isReal: this.cfgIsReal[isReal] || "",
                            cover : cover?`图${getArrIndex(pictures, +cover, 'rid')+1}`:'',
                            reply
                        });
                        this.yearsKey = nv.periods;
                        this.trendKey = nv.trend;
                        this.realKey  = nv.isReal;
                        this.coverRid = nv.cover;
                    }
                },
                deep : true
            }
        }

    }
</script>

<style scoped>

</style>